/**
 *  Copyright AlpineReplay Inc, 2021. All rights reserved.
 *  Authors: Brian Bal, Ivan Ryabov, Leonid Khramov
 */
import { connect } from "react-redux"
import React, { useState, useEffect } from "react"

import * as stat from "../../../util/analytics"
import { Page } from "../../Navigation"
import * as act from "../actions"
import TraceItem from "../components/TracerItem"
import { pageTitle, Element, Label } from "trux"
import { GamesPageHeader } from "../../../components/GamesPageHeader"
import * as links from "../../../util/links"
import "./TracersContainer.css"

const RosterListComponent = (props) => {
    const [isNewPlayerWindowOpened, setIsNewPlayerWindowOpened] = useState(false)
    const [currentRosterItem, setCurrentRosterItem] = useState(null)
    const [sort, setSort] = useState("trace_number")

    useEffect(() => {
        window.scrollTo(0,0)
        stat.statPageView()
    }, [])

    useEffect(() => {
        if (props.team) {
            pageTitle(["Rosters", props.team.title], "Team - Rosters")
        } else {
            pageTitle("Rosters", "Team - Rosters")
        }
    }, [props.team])

    const onAddPlayer = (e) => {
        if (e) {
            e.preventDefault()
        }
        var teamId = props.match.params.team
        var rosterType = props.match.params.roster_type
        var rosterId = props.match.params.roster_id

        props.history.push(
            `/${teamId}/rosters/${rosterType}/${rosterId}/players/add/-1`
        )
    }

    const onTracerItemSwap = (tracer) => {
        var traceNumber = tracer.default_trace_number

        var playerId = tracer.team_player_id
        var teamId = props.match.params.team
        var rosterType = props.match.params.roster_type
        var rosterId = props.match.params.roster_id
        if (tracer.user.is_dummy) {
            props.history.push(
                `/${teamId}/rosters/${rosterType}/${rosterId}/players/add/${traceNumber}`
            )
        } else {
            props.history.push(
                `/${teamId}/rosters/${rosterType}/${rosterId}/players/${playerId}/swap`
            )
        }

        setCurrentRosterItem(tracer)
        setIsNewPlayerWindowOpened(true)
    }

    const onTracerItemRemove = (tracer) => {
        var traceNumber = tracer.default_trace_number

        var playerId = tracer.team_player_id
        var teamId = props.match.params.team
        var rosterType = props.match.params.roster_type
        var rosterId = props.match.params.roster_id
        if (tracer.user.is_dummy) {
            props.history.push(
                `/${teamId}/rosters/${rosterType}/${rosterId}/players/add/${traceNumber}`
            )
        } else {
            props.history.push(
                `/${teamId}/rosters/${rosterType}/${rosterId}/players/${playerId}/swap/-1`
            )
        }

        setCurrentRosterItem(tracer)
        setIsNewPlayerWindowOpened(true)
    }

    const onTracerItemEdit = (tracer) => {
        var traceNumber = tracer.default_trace_number

        var playerId = tracer.team_player_id
        var teamId = props.match.params.team
        var rosterType = props.match.params.roster_type
        var rosterId = props.match.params.roster_id
        if (tracer.user.is_dummy) {
            props.history.push(
                `/${teamId}/rosters/${rosterType}/${rosterId}/players/add/${traceNumber}`
            )
        } else {
            props.history.push(
                `/${teamId}/rosters/${rosterType}/${rosterId}/players/${playerId}/edit`
            )
        }

        setCurrentRosterItem(tracer)
        setIsNewPlayerWindowOpened(true)
    }

    const onTracerItemTraceiDClick = (tracer) => {
        let playerId = tracer.user_id
        let traceiDPath = links.traceIdUrl(`/find/user/${playerId}`)
        window.location.href = traceiDPath
    }

    if (props.isLoggedIn === false) {
        return (
            <Page teamId={props.match.params.team}>
                <GamesPageHeader />
                <Element className="Tracers">
                    <Element className="trace-container">
                        <Element className="head">
                            <Label 
                                type={Label.Type.Heading1}
                                className="page-title"
                                content={"Rosters"}
                                />
                            <Label 
                                bold
                                content="You do not have permission to access this
                                team&apos;s roster"/>
                            <Label
                                content="To view or edit this roster ask the team&apos;s
                                owner to give you access"/>
                        </Element>
                    </Element>
                </Element>
            </Page>
        )
    }

    return (
        <Page teamId={props.match.params.team}>
            <GamesPageHeader />
            <Element trkContext="Roster List" className="Tracers">
                <Element className="trace-container">
                    <Element className="head">
                        <Label 
                            type={Label.Type.Heading1}
                            className="page-title"
                            content={"Players with Tracers"}
                        />
                    </Element>
                    <Element id="starters" className="tracers-list">
                        <RenderTracers
                            starters={props.starters}
                            loaded={props.loaded}
                            onSwapClick={onTracerItemSwap}
                            onEditClick={onTracerItemEdit}
                            onRemoveClick={onTracerItemRemove}
                            onTraceiDClick={onTracerItemTraceiDClick}
                        />
                    </Element>
                    <Element>
                        <Element className="head">
                            <Label 
                                type={Label.Type.Heading1}
                                className="page-title"
                                content={"Players without Tracers"}
                            />
                        </Element>
                        <Element id="bench" className="tracers-list">
                            <RenderBench
                                bench={props.bench}
                                starters={props.starters}
                                onSwapClick={onTracerItemSwap}
                                onEditClick={onTracerItemEdit}
                                onTraceiDClick={onTracerItemTraceiDClick}
                                onAddPlayer={onAddPlayer}
                            />
                        </Element>
                    </Element>
                </Element>
            </Element>
        </Page>
    )
}

const mapStateToProps = (state, props) => {
    let loaded = state.roster.complete
    let tracers = state.roster.value ? state.roster.value : []
    let gameId = null
    let game = state.game.value
    let isLoggedIn = state.isTeamLoggedIn
    let teamId = null
    if (state.team.value) {
        teamId = state.team.value.team_id
    }

    if (props.match.params.roster_type === "games") {
        gameId = props.match.params.roster_id
    }

    var starters = []
    let player
    for (var i = 1; i < 21; i++) {
        var found = false
        for (player of tracers) {
            if (player.default_trace_number === i) {
                starters.push(player)
                found = true
                break
            }
        }
        if (!found) {
            starters.push({
                team_player_id: -1,
                team_id: 9,
                user_id: -1,
                join_time: "2018-05-11 21:18:19",
                leave_time: null,
                is_active: "1",
                is_player: "1",
                is_videographer: "0",
                is_coach: "0",
                position: "",
                jersey_number: "",
                default_trace_number: i,
                invite_status: "none",
                invite_status_update_time: null,
                user: {
                    first_name: "Tracer",
                    last_name: "",
                    masked_email: "d***@traceup.com",
                    is_dummy: 1,
                },
                contacts: [],
            })
        }
    }
    starters.sort((a, b) => {
        return a.default_trace_number - b.default_trace_number
    })

    var bench = []
    for (player of tracers) {
        console.log(
            "bench",
            player.user.first_name,
            player.is_player,
            player.user.is_dummy,
            player.default_trace_number
        )
        if (
            player.is_player === "1" &&
            player.user.is_dummy === 0 &&
            player.default_trace_number <= 0 &&
            player.user.first_name !== "Tracer"
        ) {
            bench.push(player)
        }
    }

    bench.sort((a, b) => {
        var af = a.user.first_name ? a.user.first_name : ""
        return af.localeCompare(b.user.last_name)
    })

    console.log("starters", starters)
    console.log("bench", bench)

    return {
        team: state.team.value,
        loaded,
        isLoggedIn,
        starters,
        bench,
        gameId,
        game,
        teamId,
        rev: new Date(),
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        updateTracer: (tracer) => {
            dispatch(act.updateTracer(tracer))
        },
        loadGame: (gameId) => {
            console.log("loading roster game")
            dispatch(act.loadGame(gameId))
        },
        load: (teamId, gameId) => {
            console.log("loading roster season")
            dispatch(act.loadAll(teamId, gameId))
        },
    }
}

const RosterList = connect(
    mapStateToProps,
    mapDispatchToProps
)(RosterListComponent)

export default RosterList



export const RenderTracers = (props) => {
    let tracers = []
    if (props.loaded !== true) {
        for (var i = 0; i < 20; i++) {
            tracers.push(
                <Element
                    key={`roster-loading-${i}`}
                    className="TracerItem loading"
                ></Element>
            )
        }
    } else {
        tracers = props.starters.map((player, index) => (
            <TraceItem
                key={`starter-item-${index}`}
                item={player}
                onSwapClick={props.onSwapClick}
                onEditClick={props.onEditClick}
                onRemoveClick={props.onRemoveClick}
                onTraceiDClick={props.onTraceiDClick}
            />
        ))
    }

    while (tracers.length % 3) {
        tracers.push(
            <Element
                key={`tracer-shadow-${tracers.length % 3}`}
                className="shadow"
            ></Element>
        )
    }

    return tracers
}

export const RenderBench = (props) => {

    const rosterIsFull = () => {
        var full = true
        var spots = props.starters

        for (var i in spots) {
            var spot = spots[i]
            if (spot.user.is_dummy) {
                full = false
                break
            }
        }
        return full
    }

    const tracers = props.bench.map((player, index) => (
        <TraceItem
            key={`bench-item-${index}`}
            item={player}
            onSwapClick={props.onSwapClick}
            onEditClick={props.onEditClick}
            onTraceiDClick={props.onTraceiDClick}
        />
    ))

    if (rosterIsFull()) {
        tracers.unshift(
            <Element
                tag="a"
                id="roster-add-player"
                href="#add-player"
                key="trace-item-add"
                onClick={props.onAddPlayer}
                className="add-player"
                content="+ Add Another Player"
            />
        )
    }

    while (tracers.length % 3) {
        tracers.push(
            <Element
                key={`tracer-shadow-${tracers.length + 1}`}
                className="shadow"
            ></Element>
        )
    }
    return tracers
}